import { create } from "zustand";
import { useFetchMonthlyTourProgramSlice } from "../slices/MonthlyTourProgramSlices/fetchMonthlyTourProgram";
import { useFetchUserFieldWorkChildrenSlice } from "../slices/MonthlyTourProgramSlices/fetchUserFieldWorkChildrenSlice";
import { useFetchUserTerritoryBricksSlice } from "../slices/MonthlyTourProgramSlices/fetchUserTerritoryBricksSlice";
import { useFetchUserTerritorySlice } from "../slices/MonthlyTourProgramSlices/fetchUserTerritorySlice";
import { useAddTourProgramFormSlice } from "../slices/MonthlyTourProgramSlices/addTourProgramFormSlice";
import { useDeleteTourProgramSlice } from "../slices/MonthlyTourProgramSlices/deleteTourProgramSlice";
import { useFetchMonthlySmartFillSlice } from "../slices/MonthlyTourProgramSlices/fetchMonthlySmartFillSlice";
import { useAddSmartTourProgramSlice } from "../slices/MonthlyTourProgramSlices/addSmartTourProgramSlices";
import useFetchHeadQuarterListTourSlice from "../slices/MonthlyTourProgramSlices/fetchHeadQuarterListTour";

interface MonthlyTourProgramInterface
  extends ReturnType<typeof useFetchMonthlyTourProgramSlice>,
          ReturnType<typeof useFetchUserFieldWorkChildrenSlice>,
          ReturnType<typeof useFetchUserTerritoryBricksSlice>,
          ReturnType<typeof useFetchUserTerritorySlice>,
          ReturnType<typeof useAddTourProgramFormSlice>,
          ReturnType<typeof useDeleteTourProgramSlice>,
          ReturnType<typeof useFetchMonthlySmartFillSlice>,
          ReturnType<typeof useAddSmartTourProgramSlice>,
          ReturnType<typeof useFetchHeadQuarterListTourSlice> {}

export const MonthlyTourProgramStore =
  create<MonthlyTourProgramInterface>((...a) => ({
    ...useFetchMonthlyTourProgramSlice(...a),
    ...useFetchUserFieldWorkChildrenSlice(...a),
    ...useFetchUserTerritoryBricksSlice(...a),
    ...useFetchUserTerritorySlice(...a),
    ...useAddTourProgramFormSlice(...a),
    ...useDeleteTourProgramSlice(...a),
    ...useFetchMonthlySmartFillSlice(...a),
    ...useAddSmartTourProgramSlice(...a),
    ...useFetchHeadQuarterListTourSlice(...a),
  }));
